import { AreaItem } from '@/types/cms/AreaItem'
import styles from './MenuFooter.module.scss'
import { Link } from '@/components/Link'
import AppButton from '@/components/AppButton/AppButton'
import SocialLink from '@/components/SocialLink/SocialLink'

const MenuFooter = ({ item }: { item: AreaItem }) => {
  const menuSpaces = item.model?.menu?.filter((menu: any) => menu.type === 'space').slice(0, 3) ?? []

  return (
    <div className={styles['menu-footer']} data-cy="widget-menu-footer-default">
      <div className={styles['container']}>
        <div className={styles['navigation-container']}>
          <div className={styles['custom-space']}>
            <h2 className={styles['space-title']}>App holen</h2>
            <div className={styles['app-button-container']}>
              <AppButton variant={'google'} />
              <AppButton variant={'apple'} />
            </div>
          </div>
          <div className={styles['menu-group']}>
            {menuSpaces.map((menuItem: any, index: number) => (
              <div key={index} className={styles['cms-space']}>
                <h2 className={styles['space-title']}>{menuItem.title}</h2>
                {menuItem.children
                  .filter((spaceItem: any) => ['section', 'link', 'content'].includes(spaceItem.type))
                  .map((spaceItem: any, spaceIndex: number) => (
                    <Link
                      href={spaceItem.url}
                      target={spaceItem.target}
                      key={spaceIndex}
                      className={styles['space-link']}
                      arrow={spaceItem?.fields?.arrow === 'true'}
                    >
                      {spaceItem.title}
                    </Link>
                  ))}
              </div>
            ))}
          </div>
        </div>
        <div className={styles['bottom-container']}>
          <span className={styles['copyright']}>© ntv.de | Alle Rechte vorbehalten</span>
          <div className={styles['social-link-container']}>
            {['facebook', 'instagram', 'x', 'mastodon', 'rss'].map((variant, socialIndex) => (
              <SocialLink variant={variant as any} key={socialIndex} className={styles['social-link']} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MenuFooter
